import { render, staticRenderFns } from "./overtime.vue?vue&type=template&id=96504ffe&scoped=true"
import script from "./overtime.vue?vue&type=script&lang=js"
export * from "./overtime.vue?vue&type=script&lang=js"
import style0 from "./overtime.vue?vue&type=style&index=0&id=96504ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96504ffe",
  null
  
)

export default component.exports